angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerPublicationRequestListController', [
        '$localStorage', '$timeout', '$scope', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.bladeUtils', 'platformWebApp.dialogService', 'platformWebApp.uiGridHelper', 'virtoCommerce.marketplaceModule.sellerPublicationRequestStatuses',
        function ($localStorage, $timeout, $scope, api, bladeUtils, dialogService, uiGridHelper, statuses) {
            $scope.uiGridConstants = uiGridHelper.uiGridConstants;
            $scope.hasMore = true;
            $scope.items = [];

            var blade = $scope.blade;
            var bladeNavigationService = bladeUtils.bladeNavigationService;

            blade.refresh = function () {
                blade.isLoading = true;

                if ($scope.pageSettings.currentPage !== 1)
                    $scope.pageSettings.currentPage = 1;

                var searchCriteria = getSearchCriteria();

                api.listitemssearch(searchCriteria, function (data) {
                    transformByFilters(data.results);
                    blade.isLoading = false;
                    blade.approvalRequestSent = false;
                    $scope.pageSettings.totalItems = data.totalCount;
                    $scope.items = data.results;
                    $scope.hasMore = data.results.length === $scope.pageSettings.itemsPerPageCount;
                });

                if (blade.parentWidgetRefresh) {
                    blade.parentWidgetRefresh();
                }

                //reset state grid
                resetStateGrid();
            }


            function showMore() {
                if ($scope.hasMore) {

                    ++$scope.pageSettings.currentPage;
                    $scope.gridApi.infiniteScroll.saveScrollPercentage();
                    blade.isLoading = true;

                    var searchCriteria = getSearchCriteria();

                    api.listitemssearch(
                        searchCriteria,
                        function (data) {
                            transformByFilters(data.results);
                            blade.isLoading = false;
                            $scope.pageSettings.totalItems = data.totalCount;
                            $scope.items = $scope.items.concat(data.results);
                            $scope.hasMore = data.results.length === $scope.pageSettings.itemsPerPageCount;
                            $scope.gridApi.infiniteScroll.dataLoaded();

                            $timeout(function () {
                                // wait for grid to ingest data changes
                                if ($scope.gridApi.selection.getSelectAllState()) {
                                    $scope.gridApi.selection.selectAllRows();
                                }
                            });

                        });
                }
            }

            // Search Criteria
            function getSearchCriteria() {
                var searchCriteria = {
                    searchFromAllSellers: true,
                    sort: uiGridHelper.getSortExpression($scope),
                    keyword: filter.keyword,
                    skip: ($scope.pageSettings.currentPage - 1) * $scope.pageSettings.itemsPerPageCount,
                    take: $scope.pageSettings.itemsPerPageCount
                };

                if (filter.current) {
                    angular.extend(searchCriteria, filter.current);
                }

                if (blade.searchCriteria) {
                    angular.extend(searchCriteria, blade.searchCriteria);
                }

                return searchCriteria;
            }

            //reset state grid (header checkbox, scroll)
            function resetStateGrid() {
                if ($scope.gridApi) {
                    $scope.items = [];
                    $scope.gridApi.selection.clearSelectedRows();
                    $scope.gridApi.infiniteScroll.resetScroll(true, true);
                    $scope.gridApi.infiniteScroll.dataLoaded();
                }
            }

            $scope.edit = function (listItem) {
                   $scope.selectItem(null, listItem);
            };

            blade.showCategoryBlade = function (listItem) {
                var newBlade = {
                    id: "listCategoryDetail",
                    currentEntityId: listItem.id,
                    catalog: blade.catalog,
                    title: listItem.name,
                    subtitle: 'catalog.blades.category-detail.subtitle',
                    controller: 'virtoCommerce.catalogModule.categoryDetailController',
                    template: 'Modules/$(VirtoCommerce.Catalog)/Scripts/blades/category-detail.tpl.html',
                };
                bladeNavigationService.showBlade(newBlade, blade);
            };

            function isItemsChecked() {
                if ($scope.gridApi && $scope.gridApi.selection){
                    var selectedRows = $scope.gridApi.selection.getSelectedRows();
                    if (selectedRows.length > 0 && selectedRows.length === selectedRows.filter(x => x.status.includes('WaitForApproval')).length) {
                        return true;
                    }
                }
                return false;
            }

            $scope.canChangeStatus = function (data) {
                return data && data.status.includes('WaitForApproval') && !blade.approvalRequestSent;
            };

            $scope.approve = function (data) {
                massChangeStatus([data], 'Approved');
            };

            $scope.decline = function (data) {
                massChangeStatus([data], 'Rejected');
            };

            function massChangeStatus(selection, status) {
                var list = _.where(selection, { canBeModified: false });
                blade.approvalRequestSent = true;

                var operationName = status === 'Approved' ? 'Approve' : 'Decline';

                if (_.any(list)) {
                    var dialog = {
                        id: "massChangeStatus",
                        title: "Mass operation",
                        message: `${operationName} ${list.length} selected products?`,
                        callback: function (remove) {
                            if (remove) {
                                blade.isLoading = true;
                                api.massChangeStatus({ status }, { objectIds: _.pluck(list, 'id') }, blade.refresh);
                            }
                        }
                    }
                    dialogService.showConfirmationDialog(dialog);
                }
            }         

            blade.setSelectedItem = function (listItem) {
                $scope.selectedNodeId = listItem.id;
            };

            $scope.selectItem = function (e, listItem) {
                blade.setSelectedItem(listItem);

                var newBlade = {
                    id: "listItemDetail" + blade.mode,
                    itemId: listItem.productData.id,
                    sellerProduct: listItem,
                    productType: listItem.productData.productType,
                    title: listItem.name,
                    catalog: blade.catalog,
                    controller: 'virtoCommerce.catalogModule.itemDetailController',
                    template: 'Modules/$(VirtoCommerce.Catalog)/Scripts/blades/item-detail.tpl.html'
                };
                bladeNavigationService.showBlade(newBlade, blade);
            };

            $scope.canBeModified = (product) => {
                return !product.canBeModified;
            }

            blade.toolbarCommands = [
                {
                    name: "platform.commands.refresh",
                    icon: 'fa fa-refresh',
                    executeMethod: blade.refresh,
                    canExecuteMethod: function () { return true; }
                },
                {
                    name: "marketplace.blades.seller-publication-request-list.menu.approve",
                    icon: 'fa fa-cloud-upload',
                    executeMethod: function () { massChangeStatus($scope.gridApi.selection.getSelectedRows(), "Approved"); },
                    canExecuteMethod: isItemsChecked,
                },
                {
                    name: "marketplace.blades.seller-publication-request-list.menu.decline",
                    icon: 'fa fa-unlink',
                    executeMethod: function () { massChangeStatus($scope.gridApi.selection.getSelectedRows(), "Rejected"); },
                    canExecuteMethod: isItemsChecked,
                }
            ];

            function transformByFilters(data) {
                _.each(data, function (x) {
                   
                });
            }


            // simple and advanced filtering
            var filter = blade.filter = $scope.filter = {};
            $scope.$localStorage = $localStorage;
            if (!$localStorage.sellerProductsFilters) {
                $localStorage.sellerProductsFilters = [{ name: 'marketplace.blades.seller-publication-request-list.filters.add-new' }];
            }
            var stagedOrPublishedFilter = _.findWhere($localStorage.sellerProductsFilters, { id: 'staged-or-published' });
            if (!stagedOrPublishedFilter) {
                $localStorage.sellerProductsFilters.unshift({
                    id: 'staged-or-published',
                    name: 'marketplace.blades.seller-publication-request-list.filters.staged-or-published',
                    status: statuses
                });
            }
            var draftProductsFilter = _.findWhere($localStorage.sellerProductsFilters, { id: 'draft-products' });
            if (!draftProductsFilter) {
                $localStorage.sellerProductsFilters.unshift({
                    id: 'draft-products',
                    name: 'marketplace.blades.seller-publication-request-list.filters.draft-products',
                    status: ['None']
                });
            }
            if ($localStorage.sellerProductsFilterId) {
                filter.current = _.findWhere($localStorage.sellerProductsFilters, { id: $localStorage.sellerProductsFilterId });
            }

            filter.change = function () {
                $localStorage.sellerProductsFilterId = filter.current ? filter.current.id : null;
                if (filter.current && !filter.current.id) {
                    filter.current = null;
                    showFilterDetailBlade({ isNew: true });
                } else {
                    bladeNavigationService.closeBlade({ id: 'filterDetail' });
                    filter.criteriaChanged();
                }
            };

            filter.edit = function () {
                if (filter.current) {
                    showFilterDetailBlade({ data: filter.current });
                }
            };

            function showFilterDetailBlade(bladeData) {
                var newBlade = {
                    id: 'filterDetail',
                    controller: 'virtoCommerce.marketplaceModule.sellerPublicationRequestFilterController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-publication-request-filter.tpl.html'
                };
                angular.extend(newBlade, bladeData);
                bladeNavigationService.showBlade(newBlade, blade);
            }

            filter.criteriaChanged = function () {
                if ($scope.pageSettings.currentPage > 1) {
                    $scope.pageSettings.currentPage = 1;
                } else {
                    blade.refresh();
                }
            };


            // ui-grid
            $scope.setGridOptions = function (gridOptions) {

                //disable watched
                bladeUtils.initializePagination($scope, true);
                //сhoose the optimal amount that ensures the appearance of the scroll
                $scope.pageSettings.itemsPerPageCount = 50;

                uiGridHelper.initialize($scope, gridOptions, function (gridApi) {
                    //update gridApi for current grid
                    $scope.gridApi = gridApi;

                    uiGridHelper.bindRefreshOnSortChanged($scope);
                    $scope.gridApi.infiniteScroll.on.needLoadMoreData($scope, showMore);
                });

                $scope.$watch('blade.filter.showPublished', blade.refresh);
            };

            //No need to call this because page 'pageSettings.currentPage' is watched!!! It would trigger subsequent duplicated req...
        }]);
